import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BillingReportsService {

  constructor(public apiService: ApiService) { }

  public fetchBillingTemplate(): Observable<any[]> {
    return this.apiService.httpRequestBlob({
      url: 'fetchBillingTemplate',
      type: 'GET'
    });
  }

  public fetchRawBillingReport(request: any,  searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequestBlob({
      url: 'fetchBillingReport',
      type: 'POST',
      queryParams: searchQuery,
      body: request
    });
  }

  public fetchTripAmountReport(request: any, searchQuery: any): Observable<any[]> {
    return this.apiService.httpRequest({
      url: 'fetchTripAmountReport',
      type: 'POST',
      queryParams: searchQuery,
      body: request
    });
  }

  public uploadBillingReport(request: any, searchQuery): Observable<any> {
    const postData = new FormData();
    postData.append('uploadfile', request.uploadFile);
    const queryParams = {
      modifierGuid: searchQuery.modifierGuid,
      modifierBuid: searchQuery.modifierBuid,
      vendor: searchQuery.vendor,
      client: searchQuery.client,
    };
    return this.apiService.httpRequestFileUploadProgress({
      url: 'uploadBillingReport',
      type: 'POST',
      body: postData,
      queryParams,
      fileUpload: true
    });
  }

  public fetchLastUploadedFile(searchQuery): Observable<any[]> {
    return this.apiService.httpRequestBlob({
      url: 'fetchLastUploadedFile',
      type: 'GET',
      queryParams: searchQuery
    });
  }
}
